---
label: Circular Map
category: sequences
icon: CircleIcon
keywords: [circular, map, plasmid, genome, ring, topology]
addedInVersion: "0.0.0"
---

# Circular Map

Sequences with circular topology display a ring-shaped map showing the overall
layout of features on the molecule. This is especially useful for plasmids and
organellar genomes.

## Topology

Topology is set automatically when importing GenBank files — the parser reads
it from the LOCUS line. Sequences created manually default to linear.

## Switching Views

When a sequence is circular, a toggle appears in the toolbar to switch between
the linear sequence view and the circular map. Both views show the same
features.

## Reading the Map

Features appear as colored arcs around the backbone ring. Arrowheads indicate
strand direction. Features that span the origin are rendered as continuous arcs
across the boundary.

Hover over a feature arc to highlight it and reveal its label.
